export default 'Collectivités : marchés CEE conformes CCAG-PI, plan −40 % Décret Tertiaire, cumul Fonds vert + DETR + DSIL + CEE. Référencé UGAP. Pré-étude offerte.';
